import { z } from 'zod';
import {
  InvestmentOverview,
  QueryMetadata,
  type GlobalFilters,
  type QueryResult,
} from '@aurora-pvi/contracts';
import { apiFetch } from './apiFetch';
import { filterParams } from './filterParams';

/**
 * The `value` group of `Repositories`, backed by the real API
 * (`GET /investment` in apps/api) instead of the in-memory fixture.
 *
 * Same posture as `httpDeliveryRepository.ts`: parsed through the real
 * `InvestmentOverview` / `QueryMetadata` schemas, not cast, and only routed
 * for the default (unfiltered, current-period) view since `/investment` does
 * not accept `GlobalFilters` yet — see apps/api/src/routes/investment.ts for
 * which fields this route can answer honestly and which stay `null`.
 */

const Envelope = z.object({ data: InvestmentOverview, meta: QueryMetadata });

export function createHttpInvestmentRepository(baseUrl: string) {
  return {
    async getInvestment(filters: GlobalFilters): Promise<QueryResult<InvestmentOverview>> {
      const response = await apiFetch(`${baseUrl}/investment?${filterParams(filters)}`);
      if (!response.ok) {
        throw new Error(`GET /investment failed: ${response.status} ${response.statusText}`);
      }
      const json: unknown = await response.json();
      return Envelope.parse(json);
    },
  };
}
